import api from './api';
import { GetAllExperimentsResponse } from '../interfaces/Experiments';

const experimentsUIEndpointUrl = '/experiments-ui';

export const getAllExperiments =
  async (): Promise<GetAllExperimentsResponse> => {
    const response = await api.get(`${experimentsUIEndpointUrl}/descriptions`);

    return response.data;
  };

export const getExperiment = async (name: string): Promise<any> => {
  const response = await api.get(`${experimentsUIEndpointUrl}/${name}`);

  return response.data;
};

export const getExperimentHistory = async (
  name: string,
  options?: {
    page_size?: number;
    page_token?: string;
    start_date?: string;
    end_date?: string;
  },
): Promise<any> => {
  const params: Record<string, any> = { experiment_name: name };

  if (options?.page_size !== undefined) {
    params.page_size = options.page_size;
  }
  if (options?.page_token) {
    params.page_token = options.page_token;
  }
  if (options?.start_date) {
    params.start_date = options.start_date;
  }
  if (options?.end_date) {
    params.end_date = options.end_date;
  }

  const response = await api.get(
    `${experimentsUIEndpointUrl}/changelog/${name}`,
    { params },
  );

  return response.data;
};

export const getExperimentChange = async (
  name: string,
  date: string,
): Promise<any> => {
  const response = await api.get(`${experimentsUIEndpointUrl}/changes`, {
    params: { experiment_name: name, date },
  });

  return response.data;
};

export const updateExperiment = async (
  experiment: string,
  message: string,
): Promise<any> => {
  const response = await api.put(
    `${experimentsUIEndpointUrl}/update-experiment`,
    {
      experiment: JSON.parse(experiment).experiment,
      message,
    },
  );

  return response;
};
